import { createImageUrlBuilder, type SanityImageSource } from "@sanity/image-url";
import { dataset, projectId } from "./client";

const imageBuilder = createImageUrlBuilder({
    projectId: projectId || "",
    dataset: dataset || "",
});

export const urlFor = (source: SanityImageSource) => imageBuilder.image(source);

type SanityImageSourceWithAssetUrl = {
    asset?: {
        url?: unknown;
    };
};

function readDirectAssetUrl(source: SanityImageSource): string | null {
    if (!source || typeof source !== "object") return null;

    const maybeAsset = (source as SanityImageSourceWithAssetUrl).asset;
    if (!maybeAsset || typeof maybeAsset !== "object") return null;

    const maybeUrl = maybeAsset.url;
    if (typeof maybeUrl !== "string") return null;

    const trimmedUrl = maybeUrl.trim();
    return trimmedUrl.length > 0 ? trimmedUrl : null;
}

export function toSanityOriginalImageUrl(source: SanityImageSource | null | undefined): string | null {
    if (!source) return null;

    const directAssetUrl = readDirectAssetUrl(source);
    if (directAssetUrl) return directAssetUrl;

    try {
        return urlFor(source).url();
    } catch {
        return null;
    }
}
